// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2f25bf6e","239":"6bbfd831","455":"354b1280"}[chunkId] + ".chunk.js";
};